var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationsIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78762 57.4196C2.93488 59.4298 4.59721 61.0982 6.60462 62.255C8.61147 63.4111 10.8913 64.0134 13.2087 63.9998L56.812 63.9992C61.5237 63.9992 65.8773 61.4908 68.2331 57.4196C70.589 53.3479 70.589 48.3316 68.2331 44.2598L46.4321 6.57962C44.0763 2.50841 39.7228 0 35.0111 0C30.2994 0 25.9458 2.50786 23.59 6.57962L1.78762 44.2598C0.617019 46.2558 0 48.5271 0 50.84C0 53.1529 0.617047 55.424 1.78762 57.4196ZM31.7313 13.9002C31.7319 13.5915 31.9826 13.3408 32.2919 13.3408H37.7282C38.038 13.3408 38.2888 13.5915 38.2888 13.9002V40.2029C38.2888 40.5121 38.038 40.7623 37.7282 40.7623H32.2919C31.9826 40.7623 31.7319 40.5116 31.7313 40.2029V13.9002ZM31.7313 49.2292C31.7319 48.9205 31.9826 48.6704 32.2919 48.6704H37.7282C38.038 48.6704 38.2888 48.9206 38.2888 49.2292V54.6537C38.2888 54.963 38.038 55.2132 37.7282 55.2132H32.2919C31.9826 55.2132 31.7319 54.963 31.7313 54.6537V49.2292Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsIcon3);
export default __webpack_public_path__ + "static/media/OperationsIcon3.c02ece3d7c45de2490990c11914748af.svg";
export { ForwardRef as ReactComponent };